import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, FormControl, FormGroup } from '@angular/forms';
import { Pessoa } from '@tivic-team/manager-ts/dist/grl';
import { ConcessaoTipo } from '@tivic-team/manager-ts/dist/mob/enums/concessao/concessao-tipo.enum';
import { PessoaJuridicaSearch } from 'app/services/grl/pessoa-juridica.search';
import { PessoaJuridicaService } from 'app/services/grl/pessoa-juridica.service';
import { PessoaService } from 'app/services/grl/pessoa.service';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { EMPTY, from, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'auto-complete-nome-concessionario',
  templateUrl: './auto-complete-nome-concessionario.component.html',
  styleUrls: ['./auto-complete-nome-concessionario.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class AutoCompleteNomeConcessionarioComponent implements OnInit {

  formGroup: FormGroup;
  formControl: FormControl = new FormControl();

  @ViewChild("cdConcessionario", { static: false }) cdConcessionario: ElementRef;
  private _cdPessoa;

  concessionarios: Pessoa[];
  concessionariosFiltradas: Pessoa[];

  constructor(
    private _pessoaJuridicaService: PessoaJuridicaService,
    private _controlContainer: ControlContainer,
    private _pessoaService: PessoaService
  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    this.formControl.valueChanges.pipe(switchMap((value) => {
      if (value && typeof value === "string" && value.length > 2) {
        return this._pessoaJuridicaService.getPermissionario(
          new PessoaJuridicaSearch({ nmPessoa: value, tpConcessao: ConcessaoTipo.COLETIVO_URBANO })
        );
      }

      return of(null);
    })
    ).subscribe((pessoas) => {
      this.concessionariosFiltradas = pessoas
    });
  }

  async ngAfterViewInit() {
    (this.cdConcessionario.nativeElement as HTMLElement).addEventListener("input", this._limparCaracteres);
    if(this.formGroup.get('cdConcessionario').value) {
      this._carregar(this.formGroup.get('cdConcessionario').value)
      .subscribe(concessionario => this.pessoaSelecionada(concessionario));
    }
  }

  private _carregar(cdPessoa) {
    if (!cdPessoa || isNaN(cdPessoa) || this._cdPessoa === cdPessoa) return EMPTY;
    
    return from(this._pessoaService.get(cdPessoa));
  }

  pessoaSelecionada(concessionario: Pessoa) {
    if (!concessionario) return;
      
    this.cdConcessionario.nativeElement.value = concessionario.nmPessoa;
    this._cdPessoa = concessionario.cdPessoa;
    this.formGroup.patchValue({ cdConcessionario: concessionario.cdPessoa, nmPessoa: concessionario.nmPessoa });
  }

  private _limparCaracteres(event){
    event.currentTarget.value = event.currentTarget.value.replace(/[^a-zA-Zá-úÁ-Ú ]/g, '').toUpperCase();
  } 

  limparControl() {
    this.formControl.reset();
  }
}





